export default {
  methods: {
    /**
     * Ez hivja meg a processSave() metodust,
     * ha a mezok nem tartalmaznak hibat.
     * A mentes utan reseteli a validatort.
     */
    async save() {
      this.$v.$touch()

      if (this.$v.$anyError) {
        return
      }

      await this.processSave()

      this.$nextTick(() => {
        this.$v.$reset()

        if (typeof toastr !== 'undefined' && this.$store.state.canToast && ["https://www.jednoduche.sk", "http://j.local"].includes(location.origin)) {
          toastr.success('Úspešne uložené')
        }
        this.$store.commit('stopWizard', false)
      })
    },

    async redirectNonSupported() {
      const id = this.$route.params.userId

      if (id === undefined) {
        return
      }

      const subjects = await this.restDataSource.getData(id, 'subjects')

      this.$store.commit('setType', subjects.type)

      if (this.$store.state.idSupported === id) {
        return
      }

      const minSupportedYear = 18
      const danovnikYear = subjects.year

      if (danovnikYear >= minSupportedYear) {
        window.location.href = `/dpfo/${danovnikYear}/#${this.$router.currentRoute.fullPath}`
        return
      }

      if (danovnikYear < minSupportedYear) {
        window.location.href = `${process.env.VUE_APP_LEGACY_REDIR_URL}?id=${id}`
        return
      }

      this.$store.commit('setIdSupported', danovnikYear)
      this.$store.commit('nerezident', subjects.nerezident !== 1)
    },

    setDomainSettings() {
      const url = document.URL
      if (this.$store.state.domain === null) {
        if (url.startsWith('http://kominvent.nrcode.com')) {
          this.$store.commit('setDomain', '!jedno')
        } else {
          this.$store.commit('setDomain', 'jedno')
        }
      }
    },

    async setOptionsData() {
      const k = this.$store.state.kraj

      if (k.length === 0) {
        this.$store.commit('setNace', this.arrayToObject(await this.restDataSource.listObject('sknace')))
        this.$store.commit('setKraj', this.arrayToObject(await this.restDataSource.listObject('countries')))
        this.$store.commit('setKurz', (await this.restDataSource.listObject('kurz/20')))
        this.$store.commit('setZahKraj', this.arrayToObject(await this.restDataSource.listObject('countries?foreign=1')))
      }
    },

    arrayToObject (object) {
      const ret = []
      function selectOptionFormat (value, text) {
        return { value, text }
      }

      for (const key in object) {
        ret.push(selectOptionFormat(key, object[key]))
      }

      return ret
    }
  },

  inject: ['restDataSource'],

  /**
   * a mezoink tartalmanak lekerese a komponens letrejotte utan
   */
  /* watch: {
    dirty(value) {
      if (value) {
        this.$store.commit('stopWizard', true)
      } else {
        this.$store.commit('stopWizard', false)
      }
    }
  }, */

  computed: {
    dirty() {
      if (this.$v) {
        return this.$v.$anyDirty === true
      }
      return null
    }
  },

  async created() {
    await this.redirectNonSupported()
    this.setDomainSettings()
    await this.setOptionsData()
    await this.processGet()

    this.$nextTick(() => {
      if (this.$v) {
        this.$v.$reset()
      }
    })
  },

  beforeRouteLeave(to, from, next) {
    if (typeof this.$v === 'undefined') {
      next()
      return
    }

    if (this.$v.$anyDirty == true) {
      next()
      return
    }

    if (this.$store.state.stopWizard !== true) {
      next()
      return
    }

    const answer = window.confirm('Ďalej bez uloženia údajov?')
    if (answer === true) {
      this.$store.commit('stopWizard', false)
      next()
      return
    }

    // cancel
    this.$store.commit('stopWizard', true)
    this.$emit('on-loading', true)
    next(false)
  }
}
